import React from 'react';
import { Grid, IconButton, Paper, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { BoardSchemeInterface } from 'ts-interfaces';
import { DisplayBoards } from '../../boards_scheme/DisplayBoards';

interface BoardsPanelProps {
  boards: BoardSchemeInterface[];
  designFirms: any[];
  teamMembers: any[];
  permissions: any;
  hasViewerAccess?: boolean;
  onBoardUpdate: (board: BoardSchemeInterface, addBoard?: boolean) => Promise<void>;
  onOpenModal: () => void;
}

export const BoardsPanel = ({
  boards,
  designFirms,
  teamMembers,
  permissions,
  hasViewerAccess = false,
  onBoardUpdate,
  onOpenModal
}: BoardsPanelProps) => {
  return (
    <Paper sx={{ p: 3, height: '100vh' }}>
      <Grid sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 'medium' }}>
          Boards
        </Typography>
        {!hasViewerAccess &&
          <IconButton
            aria-label="add board" 
            sx={{ 
              bgcolor: 'white', 
              border: '1px solid #333', 
              borderRadius: '4px', 
              padding: '4px' 
            }} 
            onClick={onOpenModal}
          >
            <AddIcon sx={{ color: 'black' }} />
          </IconButton>
        }
      </Grid>
      <Grid container spacing={2}>
        <DisplayBoards 
          data={boards} 
          onBoardUpdate={onBoardUpdate} 
          designFirms={designFirms} 
          teamMembers={teamMembers} 
          cardSize='small' 
          hasViewerAccess={hasViewerAccess}
        />
      </Grid>
    </Paper>
  );
};